import { NavItemEnum } from '../../constants/routing/NavItems';
import { UseCases, useCasesQueryParamKey } from './constants';
export const getUseCasesByPage = page => {
  switch (page) {
    case NavItemEnum.MARKETING:
    case NavItemEnum.CONTENT:
    case NavItemEnum.MARKETING_PLUS:
      return [UseCases.MARKETING];
    case NavItemEnum.SALES:
    case NavItemEnum.COMMERCE:
      return [UseCases.SALES];
    case NavItemEnum.SERVICE:
      return [UseCases.SERVICE];
    case NavItemEnum.FREE:
    case NavItemEnum.SMART_CRM:
    case NavItemEnum.DATA:
      return [UseCases.SMART_CRM];
    case NavItemEnum.SUITE:
      return [UseCases.MARKETING, UseCases.SALES, UseCases.SERVICE, UseCases.SMART_CRM];
    case NavItemEnum.HUBSPOT_CREDITS:
    case NavItemEnum.BUNDLE:
    default:
      return [UseCases.MARKETING];
  }
};
const isUseCase = value => {
  return Object.values(UseCases).some(useCase => useCase === value);
};
export const getValidUniqueUseCasesParams = searchParams => {
  const search = typeof searchParams === 'string' ? new URLSearchParams(searchParams) : searchParams;
  const useCases = search.getAll(useCasesQueryParamKey);
  const uniqueUseCases = new Set(useCases.filter(isUseCase));
  const wasModified = uniqueUseCases.size !== useCases.length;
  search.delete(useCasesQueryParamKey);
  for (const useCase of uniqueUseCases) {
    search.append(useCasesQueryParamKey, useCase);
  }
  return {
    wasModified,
    search: search.toString()
  };
};